//option pre-fetching from jira currently unneeded, placed here to be used in future if needed
import API from "../APIs/API";

export interface SelectOption {
    label: string;
    value: any;
    [key: string]: any; // Allow for additional properties
}

export const vbfTypeOptions: SelectOption[] = [
  { value: "", label: "--Please Select--" },
  { value: "TRADITIONAL", label: "Traditional" },
  { value: "COMPLEX", label: "Complex" },
]

export const criticalAttributesImpactedOptions = [
  { value: "HOMOLOGATION", label: "Homologation" },
  { value: "PT_CERT", label: "Powertrain Certification" },
  { value: "KOL", label: "KOL (Key-Off Load)" },
  { value: "EOL", label: "EOL (End Of Line)" },
  { value: "EMC", label: "EMC (Electromagnetic Compatibility)" },
  { value: "CMA", label: "CMA (CAN Message Authentication Message)" },
  { value: "NETCOM", label: "NETCOM (Network Communications)" },
];

export const lveaOptions = [
  { value: "FNA", label: "FNA" },
  { value: "FoE", label: "FoE" },
  { value: "FoC", label: "FoC" },
  { value: "IMG", label: "IMG" },
  { value: "FSA", label: "FSA" },
  { value: "JV_Otosan", label: "JV Otosan" },
  { value: "FoA", label: "FoA" },
];

export const gpdsMilestoneOptions = [
  { value: "", label: "--Please Select--" },
  { value: "DCV0", label: "DCV0" },
  { value: "DCV1", label: "DCV1" },
  { value: "DCV2", label: "DCV2" },
  { value: "DCV3", label: "DCV3" },
  { value: "TPV", label: "TPV" },
  { value: "FDJ", label: "FDJ" },
  { value: "PEC", label: "PEC" },
  { value: "FEC", label: "FEC" },
  { value: "EPT1/2", label: "EPT1/2" },
  { value: "TT1", label: "TT1" },
  { value: "TT2", label: "TT2" },
  { value: "TT3", label: "TT3" },
  { value: "PP1", label: "PP1" },
  { value: "PP2", label: "PP2" },
  { value: "PP3", label: "PP3" },
  { value: "MP1", label: "MP1" },
  { value: "MP2/OKTB", label: "MP2/OKTB" },
];

export const macsecEnabledOptions = [
  { value: "", label: "--Please Select--" },
  { value: true, label: "true" },
  { value: false, label: "false" },
];

export const cmaEnabledOptions = [
  { value: "", label: "--Please Select--" },
  { value: true , label: "true" },
  { value: false , label: "false" },
];

export const asilRatingOptions = [
  { value: "", label: "--Please Select--" },
  { value: "QM", label: "QM" },
  { value: "A", label: "A" },
  { value: "B", label: "B" },
  { value: "C", label: "C" },
  { value: "D", label: "D" },
]

export const f163D2SpecVersionOptions = [
  { value: "Not Listed", label: "Not Listed" },
  { value: "GGDS 001", label: "GGDS 001" },
  { value: "GGDS 002", label: "GGDS 002" },
  { value: "GGDS 003", label: "GGDS 003" },
  { value: "GGDS 004", label: "GGDS 004" },
  { value: "GGDS 005", label: "GGDS 005" },
  { value: "GGDS 006", label: "GGDS 006" },
  { value: "N/A", label: "N/A" },
];

export const yesNoDropdownOptions = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];

export const trueFalseDropdownOptions = [
  { value: true, label: "true" },
  { value: false, label: "false" },
];

export const swSignRequestOptions = [
  { value: "", label: "--Please Select--" },
  { value: "NO_SIGN", label: "Not Required" },
  { value: "DEV_SIGN", label: "Dev Sign Required" },
  { value: "PROD_SIGN", label: "Prod Sign Required" },
]

export const swSignRequestDisabledOptions = [
  { value: "", label: "--Please Select--" },
  { value: "NO_SIGN", label: "Not Required" },
]

export const swDownloadMethodOptions = [
  { value: "", label: "--Please Select--" },
  { value: "wifi-first", label: "Wifi First" },
  { value: "wifi", label: "Wifi" },
  { value: "cellular", label: "Cellular" },
]

export const softwareCategoryOptions = [
  { value: "", label: "--Please Select--" },
  { value: "APP APPLICATION", label: "APP APPLICATION" },
  { value: "APP ECU_CONFIGURATION", label: "APP ECU_CONFIGURATION" },
  { value: "APP SCRIPTING_APPLICATION", label: "APP SCRIPTING_APPLICATION" },
  { value: "APP CALIBRATION", label: "APP CALIBRATION" },
  { value: "APP CBZ_MAP_DATA", label: "APP CBZ_MAP_DATA" },
  { value: "APP SYNC_VOICE_DATA", label: "APP SYNC_VOICE_DATA" },
  { value: "DIV IMAGE", label: "DIV IMAGE" },
  { value: "DIV PRIMARY_BOOTLOADER", label: "DIV PRIMARY_BOOTLOADER" },
  { value: "DIV SECONDARY_BOOTLOADER", label: "DIV SECONDARY_BOOTLOADER" },
  { value: "DIV STRATEGY", label: "DIV STRATEGY" },
  { value: "DIV BOOT_IMAGE", label: "DIV BOOT_IMAGE" },
];

export const relationshipTypeOptions = [
  { value: "", label: "--Please Select--" },
  // COORDINATED_WITH, DEPENDENT_ON
  { value: "COORDINATED_WITH", label: "Coordinated With" },
  { value: "DEPENDENT_ON", label: "Dependent On" },
];

export const versionChangeLevelOptions = [
  { value: "", label: "--Please Select--" },
  { value: "NO CHANGE", label: "NO CHANGE" },
  { value: "MAJOR", label: "MAJOR" },
  { value: "MINOR", label: "MINOR" },
  { value: "PATCH", label: "PATCH" },
];

export const actionTypeOptions = [
  { value: "", label: "--Please Select--" },
  { value: "add", label: "add" },
  { value: "update", label: "update" },
  { value: "remove", label: "remove" },
]

export const programmingMethodOptions = [
  { value: "", label: "--Please Select--" },
  { value: "ETH-SFTP", label: "ETH-SFTP" },
  { value: "ETH-OVTP", label: "ETH-OVTP" },
  { value: "CAN-OVTP", label: "CAN-OVTP" },
  { value: "CAN-UDS", label: "CAN-UDS" },
  { value: "CANFD-UDS", label: "CANFD-UDS" },
]

export const moduleNameDropdownOptions = [
  "GWM",
  "TCU",
  "TCU_6.75",
  "RIGIl",
  "ABS",
  "ACCM",
  "ACCMB",
  "ACM",
  "ATCM",
  "AWD",
  "BCM",
  "BCMB",
  "BCMC",
  "BECM",
  "CCM",
  "CHCM",
  "CMR",
  "DCACA",
  "DCACB",
  "DCDC",
  "DCME",
  "DCMF",
  "DCMG",
  "DCMH",
  "DDM",
  "DLM",
  "DSM",
  "DSP",
  "FHCM",
  "GFM",
  "GFM2",
  "GSM",
  "HCM",
  "HPVCM",
  "HUD",
  "HVAC",
  "IPC",
  "IPMA",
  "LDCMA",
  "LDCMB",
  "OBCC",
  "OCS",
  "PACM",
  "PBM",
  "PCM",
  "PDC",
  "PDM",
  "PSCM",
  "RACM",
  "RCM",
  "RFA",
  "RGTM",
  "RHVAC",
  "RTM",
  "SCCM",
  "SCMB",
  "SCMC",
  "SCMD",
  "SCME",
  "SCMF",
  "SCMG",
  "SCMH",
  "SCMJ",
  "SCMK",
  "SCML",
  "SIMA",
  "SOBDMA",
  "SOBDMB",
  "SOBDMC",
  "SOBDMD",
  "SODCMC",
  "SODCMD",
  "SODL",
  "SODR",
  "SUMA",
  "TCCM",
  "TCM",
  "TRM",
  "TTPMS",
  "UCIM",
  "VDM",
  "WCM"
].map((item) => {
  return {
      label: item,
      value: item
  }
});


export async function setSupplierFieldOptions(
  {
    setDynamicSelectOptionsMap,
    api
  }: {
    setDynamicSelectOptionsMap: React.Dispatch<React.SetStateAction<Record<string, SelectOption[]>>>,
    api: API
  }
){
    try {
      const fieldOptions = await getSupplierOptions(api);
      const newSupplier = fieldOptions.map((option) => option.value);

      // TODO: Remove this ICA once confident that the new supplier fetch logic is working without any issue. The ICA remains to help with feature-flag rollback is necessary
      injectMissingSuppliersICA(newSupplier)

      const newOptionsSet = new Set([...newSupplier]);
      const newOptions = Array.from(newOptionsSet).map((option) => {
          if (option === "") {
              return {
                  label: "--Please select--",
                  value: "",
              }
          }
          else if (option === "WDP") {
            return {
                label: "Wdp",
                value: "Wdp",
            }
          }
          return {
              label: option,
              value: option
          }
      });
      newOptions.sort((a, b) => a.label.localeCompare(b.label));
      setDynamicSelectOptionsMap((prevState => ({
          ...prevState,
          supplier: newOptions
      })));
    } catch (error: any) {
      console.error("Error fetching Supplier options:", error.message);
      const options = [
        { label: "--Please select--", value: "" }];
      setDynamicSelectOptionsMap((prevState => ({
        ...prevState,
        supplier: options
      })));
    }
}

// TODO: Remove this ICA, implement PCA
const injectMissingSuppliersICA = (newSuppliers: Array<any>) => {

  newSuppliers.push("Aumovio");
}

const getSupplierOptions = async (api: API) => {

  const response = await api.fetch(`/srp/form/suppliers`);
  
  if (!response.ok || response.status !== 200) {
    console.warn("ERROR WHEN FETCHING SUPPLIER OPTIONS:", response.status, response.statusText);

    if (response.status === 500) {
      const errorData = await response.json();
      throw new Error(`Error fetching supplier options: ${errorData.message}`);
    }

    throw new Error(`Error fetching supplier options: ${response.statusText}`);
  }

  const suppliers = await response.json();

  console.log(`Fetched ${suppliers.length} supplier options`);

  const optionsArray: SelectOption[] = suppliers.map((supplier: any) => ({
    label: supplier,
    value: supplier
  }));

  return optionsArray;

}